export const SEARCH_SPLIT_REGEX = /[\s+/]/g;
